
export const dev = {
    /*
    If true the browser is supposed to be safari or part of the safari family.
    */
    isSafari: false,
    /*
    True if the browser seems to be Google Chrome.
    */
    isChrome: false,
    /*
    True if the browser seems to be Opera.
    */
    isOpera: false,
    /*
    If true the browser is supposed to be part of the mozilla family (usually
    FireFox).
    */
    isMoz: false,
    /*
    True if the browser seems to be Internet Explorer. Also true if we where not
    able to detect the browser type properly (if browser unknown threat it as IE
    policy).
    */
    isIE: false,
    /* 
    True if the browser seems to be Microsoft Edge.
    */
    isEdge: false,
    /*
    True if the WebKit layout engine is used (Safari & Chrome).
    */
    isWebkit: false,

    isMobile: false,
    isIOS: false,


    /* 
    Performs the device detection based on the user agent string. This sets / updates the isSafari, 
    isIE, .. properties!
    */
    detectDevice() {
        //  Check if something actually changed
        if (this._sPrevUA !== navigator.userAgent) {
            this._sPrevUA = navigator.userAgent;

            //  Reset values
            this.isSafari = false;
            this.isChrome = false;
            this.isOpera = false;
            this.isMoz = false;
            this.isIE = false;
            this.isEdge = false;
            this.isWebkit = false;
            this.isMobile = false;
            this.isIOS = false;

            // Check what browser we are using
            this.isEdge    = navigator.userAgent.includes("Edg/");
            this.isOpera   = navigator.userAgent.includes("OPR/") || navigator.userAgent.includes("Opera");
            this.isMoz = navigator.userAgent.includes("Firefox/");
            this.isSafari  = navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome") && !this.isEdge && !this.isOpera;
            this.isChrome  = navigator.userAgent.includes("Chrome") && !this.isEdge && !this.isOpera;
            this.isIE      = /Trident|MSIE/.test(navigator.userAgent);

            // Determine if this is a mobile device (tablet or mobile phone).
            const isMobileDevice = /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/.test(navigator.userAgent);
            // Coarse pointer media query determines if the device primarily uses touch input.
            const hasCoarsePointer = window.matchMedia("(pointer: coarse)").matches;

            // IsMobileDevice is leading, but we also consider coarse pointer devices as mobile
            this.isMobile = isMobileDevice || hasCoarsePointer;

            // Check if the specified device is IOS
            this.isIOS     = /iPad|iPhone|iPod/.test(navigator.userAgent);

            // Check if the browser uses Webkit engine
            this.isWebkit  = navigator.userAgent.includes("AppleWebKit") && !this.isIE;
        }
    }
}

dev.detectDevice();